import React from 'react';
import anime from '../utils/anime.es';

const anims = {}

export default function CoffeeSvg({isShowing}) {
  const l1 = React.useRef(null);
  const l2 = React.useRef(null);
  const r1 = React.useRef(null);
  const r2 = React.useRef(null);
  const head = React.useRef(null);

  React.useEffect(() => {
    anims.head = anime({
      targets: head.current,
      loop: 4,
      autoplay: false,
      translateY: [
        { value: [0, -1], duration: 100 },
        { value: 1 },
        { value: -2 },
        { value: 1 },
        { value: -1 },
        { value: 1 },
        { value: 0 },
        { value: 0, duration: 100 },
      ],
      rotate: [
        { value: 0.5 },
        { value: -0.5 },
        { value: 0.5 },
        { value: -0.5 },
        { value: 0.5 },
        { value: -0.5 },
      ],
      duration: 500,
    });

    anims.buzz = anime
    .timeline({
      autoplay: false,
      loop: true,
    })
    .add({
      targets: [l1.current, l2.current],
      translateX: [
        { value: -5, duration: 500 },
        { value: 2, duration: 400 },
        { value: 0 },
      ],
      rotate: [{ value: 1 }, { value: -1 }, { value: 1 }, { value: -1 }],
      delay: anime.stagger(100),
      easing: "easeInOutSine",
    })
    .add({
      targets: [r2.current, r1.current],
      translateX: [
        { value: 5, duration: 500 },
        { value: -2, duration: 400 },
        { value: 0 },
      ],
      rotate: [{ value: -1 }, { value: 1 }, { value: -1 }, { value: 1 }],
      delay: anime.stagger(100),
      easing: "easeInOutSine",
    }, 0)
    
    anims.flyIn = anime
    .timeline({
      autoplay: false,
      complete: () => {
        anims.head.play();
        anims.buzz.play();
      }
    })
    .add({
      targets: [
        l1.current,
        l2.current,
        head.current,
        r1.current,
        r2.current,
      ],
      translateY: [200, 0],
      rotate: [45, 0],
      opacity: [{ value: [0, 1], easing: "easeOutSine", duration: 500 }],
      duration: 1000,
      delay: anime.stagger(100, { from: "center" }),
    })
  }, [])

  React.useEffect(() => {
    if(isShowing) {
      if (anims.flyIn.completed && (anims.head.completed || !anims.head.began)) {
        anims.head.play();
      }
      if (!anims.flyIn.began) {
        anims.flyIn.play();
      }
    } 
  }, [isShowing])

  return (
    <svg id="coffee" viewBox="0 0 300 300">
      <defs>
        <style>
          {`
            #head{transform-origin:151px 135px}#l1{transform-origin:62px 163px}#l2{transform-origin:81px 159px}#r1{transform-origin:230px 156px}#r2{transform-origin:250px 159px}
          `}
        </style>
      </defs>
      <filter id="blurMe">
        <feGaussianBlur stdDeviation=".8" />
      </filter>
      <g ref={l2} 
        id="l2"
        filter="url(#blurMe)"
      >
        <polygon points="83.09 189.56 75.62 176.56 82.34 159.75 75.68 146.79 81.14 128.75 84.97 129.9 79.98 146.4 86.73 159.55 80.05 176.25 86.56 187.56 83.09 189.56" />
      </g>
      <g 
        ref={l1} 
        id="l1"
        filter="url(#blurMe)"
      >
        <polygon points="63.68 187.78 57.26 176.55 63.45 161.5 57.22 153.39 62.72 138.4 66.47 139.78 61.74 152.7 68.03 160.89 61.7 176.26 67.15 185.8 63.68 187.78" />
      </g>
      <g 
        ref={r2} 
        id="r2"
        filter="url(#blurMe)"
      >
        <polygon points="248.16 184.16 244.78 182.02 250.42 173.09 244.12 157.77 250.41 149.58 245.67 136.66 249.43 135.28 254.92 150.27 248.69 158.38 254.91 173.48 248.16 184.16" />
      </g>
      <g 
        ref={r1} 
        id="r1"
        filter="url(#blurMe)"
      >
        <polygon points="228.02 186.48 224.68 184.28 232.07 173.06 225.41 156.43 232.16 143.28 227.17 126.78 231 125.63 236.46 143.67 229.8 156.63 236.56 173.51 228.02 186.48" />
      </g>
      <g ref={head} id="head">
        <path d="M89,107.51l1.24,2.42c3.14,6.06,10.37,8.52,14.79,9.49-2.83,2.09-5.35,4-5.35,4l-2.48,1.85,3,.8a31.07,31.07,0,0,0,8.13,1,36.22,36.22,0,0,0,4.43-.29,4,4,0,0,0-1.47,1.2c-.7,1.68.36,5.48,2.21,5.56a2.09,2.09,0,0,0,.4,0c-.38,47.26,6.4,67.66,6.71,68.58l.32.94,1,.07c3,.22,5.86.32,8.65.32,35.22,0,55.39-16.32,56.3-17.07l.4-.34.11-.51c1.8-8.49,3.1-16.5,4-23.37a8.25,8.25,0,0,0,3.21.67c2.89,0,5.7-1.64,8.1-4.87,5.11-6.85,7.54-20.15,2.92-23.85a7.89,7.89,0,0,0-6-1.75h0l-1.24-3.43,3.36-4.42-1.11-3a29.8,29.8,0,0,0,9.76.46l4.32-.56-3.75-2.22c-4.31-2.54-4.36-5-4.44-8.65-.07-3.18-.15-7.14-3.52-11.53-5.33-6.94-11-7.23-13.88-6.82-1-5.54-5.53-22.8-24.11-24.9-13.3-1.5-18.58,3.75-24.17,9.31C137.28,80.2,133.5,84,127,86.3,111.17,92,100.94,85,100.51,84.72l-3.1-2.18.77,3.71a23.11,23.11,0,0,0,10.12,14.57,21.14,21.14,0,0,1-16.55,6.93Zm89.54,3.25-1.51-1c2.71-4.2,3.82-12.56.91-18.74-2.14-4.52-6.14-7.25-11.55-7.88-7.75-.89-15.54,5.15-23.08,11-8,6.2-15.54,12.07-23.25,10.39l.39-1.76c6.88,1.5,14.11-4.11,21.76-10,7.82-6.08,15.9-12.35,24.38-11.37,7.67.88,11.29,5.33,13,8.89C182.83,97.1,181.62,106.05,178.58,110.76ZM191.84,159c.41-3.28.73-6.24,1-8.8.12-1.12.22-2.27.31-3.4.37-4.29.48-6.82.49-6.89h-.06c0-.4,0-.78.05-1.13,1.61-1.54,6.32-5.46,10.19-2.35,2.71,2.18,1.31,13.33-3.45,19.72C197.69,159.72,194.83,160.67,191.84,159Zm-6.41-60.57-1.84,1.49L184,97.6a17.8,17.8,0,0,0-2.14-10.26l1.59-.85a20.68,20.68,0,0,1,2.45,9.63,8.49,8.49,0,0,1,8.81.89l-1.05,1.46A6.8,6.8,0,0,0,185.43,98.44ZM190,110.71l-1.78.29c-1-6.32-5.24-7.34-5.42-7.38l.19-.88.19-.88C183.45,101.9,188.77,103.13,190,110.71Zm-73.1,21.89c4.34-1.63,11.08-4.88,11.59-6.36a4.47,4.47,0,0,0-.9-3.84,78.94,78.94,0,0,0,17.65-11.27,42.18,42.18,0,0,1,15.88-.85,31.56,31.56,0,0,1,12.78,5.27v7.51c-1.17-1.77-17.37-5.55-20.53-5.79S147.5,121.34,149,124s17.82,7.43,21.62,6.39a5,5,0,0,0,3.32-2.77v.46l.92.39c.09,0,8.34,3.55,7.91,9-.53,6.62-1.15,14.83-1.15,14.83l-.09,1.2,1.15.35a14,14,0,0,0,4,.54,22.81,22.81,0,0,0,2.68-.17c-.88,8-2.37,18.61-4.8,30.17-3.21,2.43-25.51,18.17-61.4,15.84C121.88,195.66,116.55,174.46,116.94,132.6Z" />
        <path d="M132.63,169.51a11.7,11.7,0,0,1-3.63-3.06,3.49,3.49,0,0,1-.78-2.64,254.45,254.45,0,0,1,9.48-39.09l2.84,1a248.31,248.31,0,0,0-9.35,38.52c.12.92,3.67,4.3,11,5.39l0,.3h.06s7.46,2.6,12,4.37c.58.47.43,6-.15,7.53s-6.68-.59-6.68-.59-6.42,1.41-8.09-.35c0,0-2.84,2.12-9,.12,0,0-4.84,1.29-6.09.11-.59-.7-.5-5.06-.25-6.47C124.17,173.44,130.53,170.47,132.63,169.51Z" />
        <path d="M122.79,150a2.5,2.5,0,1,1,2.5-2.49A2.49,2.49,0,0,1,122.79,150Z" />
        <circle cx="157.61"
                cy="145.04"
                r="2.91" />
        <path d="M157.61,155.82A10.78,10.78,0,1,0,146.83,145,10.79,10.79,0,0,0,157.61,155.82ZM148.56,145a9.05,9.05,0,1,1,9.05,9.05A9.06,9.06,0,0,1,148.56,145Z" />
      </g>
    </svg>

  )
}
